export default __webpack_public_path__ + "static/media/diastolic.869a831a.svg";